import { getLabelName } from "../../utils";
import { Accordion } from "react-bootstrap";
import { TransactionDueDateList } from "./transactionDueDateList";
import { TransactionDueDateForm } from "./transactionDueDateForm";

export const TransactionDueDateMainComponent = () => {
  return (
    <div>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            {getLabelName("Manage Transaction due Date")}
          </Accordion.Header>
          <Accordion.Body>
            <TransactionDueDateForm />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>{getLabelName("Previous Data")}</Accordion.Header>
          <Accordion.Body>
            <TransactionDueDateList />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};
